import { colors } from "../../utils/const";

export const styles = {
  container: (theme) => ({
    display: "flex",
    alignItems: "start",
    gap: 3,
    minHeight: "300px",
  }),
  link: (theme) => ({
    pb: 0.5,
    color: colors.orange,
    fontSize: "17px",
    fontWeight: "bold",
    textDecoration: "none",
    "&:hover": {
      color: colors.orange,
    },
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    // width: { md: "80%" },
  }),
};
